export function greenRedPaletteGenerator(ratio: number): string {
  // todo use something from d3.colorRange
  const green = Math.floor(ratio > 0.5 ? 255 : (255 * ratio) / 0.5);
  const red = Math.floor(ratio < 0.5 ? 255 : (255 * (1 - ratio)) / 0.5);

  return `rgba(${red},${green},30,1)`;
}
